import CAP_EXT_1 from "./CAP_EXT_1";
export default {
  CAP_EXT_1,
};
